import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes';
import AccessibilityWidget from './components/AccessibilityWidget';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <AppRoutes />
        <AccessibilityWidget />
      </div>
    </AuthProvider>
  );
}

export default App;
